import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { mobile } from '../../theme/media';

export const scenarioBanner = style({
  padding: '12px 20px',
  background: vars.stateColor.gold.scenarioBannerGradient,
  borderBottom: `1px solid ${vars.stateColor.gold.bannerBorderStrong}`,
  position: 'relative',
  '@media': {
    [mobile]: {
      padding: '10px 16px',
    },
  },
});

export const scenarioBannerLine = style({
  height: '1px',
  background: vars.stateColor.gold.scenarioLineGradient,
});

export const scenarioBannerContent = style({
  padding: '10px 0',
  textAlign: 'center',
});

export const scenarioLabel = style({
  display: 'block',
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize['2xs'],
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.bright.textHighlight.scenario,
  letterSpacing: '0.15em',
  marginBottom: '6px',
  textShadow: vars.stateColor.gold.scenarioLabelShadow,
  '@media': {
    [mobile]: {
      fontSize: vars.typography.fontSize['3xs'],
      marginBottom: '4px',
    },
  },
});

export const scenarioMessage = style({
  display: 'block',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
  color: vars.stateColor.gold.messageColor,
  letterSpacing: vars.typography.letterSpacing.semiWide,
  textShadow: vars.stateColor.gold.scenarioMessageShadow,
  '@media': {
    [mobile]: {
      fontSize: vars.typography.fontSize.xs,
    },
  },
});
